import { createContext } from 'react';
import { emptyFunc } from '@shared/react';
import { PaginationOptions } from '@features/Pagination';
import { ITransactionDesc } from './ClientDetailsTableProvider';
import { ISettingsAccountsDto } from '@shared/api';

type DateRange = [string | null, string | null];

export interface IClientDetailsTableContext {
    dateRange: DateRange;
    ClientDetailsBody: ISettingsAccountsDto[];
    logoLoading: boolean;
    paginationOptions: PaginationOptions | null;
    sortFieldName: string;
    desc: ITransactionDesc | null;
    userType: string | null;
    clientLoading: boolean;
    setClientDetailsIdentifier: (symbol: string) => void;
    setCusip: (cusip: string) => void;
    setDateRange: (range: DateRange) => void;
    setUserType: (value: string) => void;
}

export const ClientDetailsTableContext = createContext<IClientDetailsTableContext>({
    dateRange: [null, null],
    ClientDetailsBody: [],
    logoLoading: false,
    paginationOptions: null,
    clientLoading: false,
    sortFieldName: '',
    desc: null,
    userType: '',
    setClientDetailsIdentifier: emptyFunc,
    setCusip: emptyFunc,
    setDateRange: emptyFunc,
    setUserType: emptyFunc,
});
